var EasyTips = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_easytips',
		offset: { x: 0, y: 0 },
		position: 'above', // above/top/up, below/bottom/down/under, leftside/left, rightside/right
		content: function(_el){
			return _el.getElement('.tooltip') || 'Use option \'content\' to set content to the tooltip';
		},
		parent: null
	},

	initialize: function(elements, options){
		this.setOptions(options);
		this._elements = elements;

		if(this._elements){
			this.build();
		}
	},

	build: function(){
		if(typeOf(this._elements) == 'element'){
			this._elements = [this._elements];
		}

		var opts = this.options;
		var self = this;

		this._container = new Element('.' + opts.cls);
		this._container.inject(document.body, 'bottom');
		this._tt_content = new Element('.w_easytips_content').inject(this._container);
		this._tt_tail = new Element('.w_easytips_tail').inject(this._container);

		this.intip = this.inelement = this.inparent = false;

		if(opts.parent){
			opts.parent.addEvents({
				'mouseenter': function(){
					self.inparent = true;
					if(self._current_el) self._current_el.addClass('_tipped');
				},

				'mouseleave': function(){
					(function(){
						if(!self.intip && !self.inelement && !self.inparent){
							self._container.hide();
							self._current_el = null;
						}
					}).delay(50);

					self.inparent = false;
					if(!self.inelement && !self.intip){
						self.fireEvent('hide', [self._current_el]);
						if(self._current_el) self._current_el.removeClass('_tipped');
					}
				}
			});
		}

		this._container.addEvents({
			'mouseenter': function(){
				self.intip = true;
				if(self._current_el) self._current_el.addClass('_tipped');
			},

			'mouseleave': function(){
				(function(){
					if(!self.intip && !self.inelement && !self.inparent){
						self._container.hide();
						self._current_el = null;
					}
				}).delay(50);

				self.intip = false;
				if(!self.inelement && !self.inparent){
					self.fireEvent('hide', [self._current_el]);
					if(self._current_el) self._current_el.removeClass('_tipped');
				}
			}
		});

		this._elements.each(function(_el){
			_el.addEvents({
				'mouseenter': function(){
					self._container.show();

					if(self._current_el !== _el){
						self.set_content(_el);
						self.set_position(_el);
						self.fireEvent('show', [_el]);
					}

					self.inelement = true;

					if(self._current_el) self._current_el.removeClass('_tipped');
					_el.addClass('_tipped');
					self._current_el = _el;
				},

				'mouseleave': function(){
					(function(){
						if(!self.intip && !self.inelement && !self.inparent){
							self._container.hide();
							self._current_el = null;
						}
					}).delay(50);

					self.inelement = false;

					if(!self.intip && !self.inparent){
						self.fireEvent('hide', [_el]);
						if(self._current_el) self._current_el.removeClass('_tipped');
					}
				}
			});
		});

		document.addEvent('touchend', function(e){
			if(e.target && self._current_el && e.target !== self._current_el){
				self._current_el.fireEvent('mouseleave');
			}
		});
	},

	set_position: function(_el){
		var opts = this.options;
		var self = this;
		var left = _el.getCoordinates().left;
		var top = _el.getCoordinates().top;

		self._container.fade('hide');

		var el_width = _el.getAttribute('data-width') || _el.getSize().x;
		var el_height = _el.getAttribute('data-height') || _el.getSize().y;
		var cont_width = this._container.getSize().x;
		var cont_height = this._container.getSize().y;

		var shift_x;
		var shift_y;

		if(opts.position == 'above' || opts.position == 'top' || opts.position == 'up'){
			this._container .removeClass('_bottom')
											.removeClass('_left')
											.removeClass('_right')
											.addClass('_top');

			shift_x = (el_width - cont_width)/2;
			shift_y = -cont_height - this._tt_tail.getSize().y;
		} else if(opts.position == 'below' || opts.position == 'bottom' || opts.position == 'down' || opts.position == 'under'){
			this._container .removeClass('_top')
											.removeClass('_left')
											.removeClass('_right')
											.addClass('_bottom');

			shift_x = (el_width - cont_width)/2;
			shift_y = el_height + this._tt_tail.getSize().y;
		} else if(opts.position == 'rightside' || opts.position == 'right'){
			this._container .removeClass('_top')
											.removeClass('_bottom')
											.removeClass('_left')
											.addClass('_right');

			shift_x = el_width + this._tt_tail.getSize().x;
			shift_y = (el_height - cont_height)/2;
		} else {
			this._container .removeClass('_top')
											.removeClass('_bottom')
											.removeClass('_right')
											.addClass('_left');

			shift_x = -cont_width - this._tt_tail.getSize().x;
			shift_y = (el_height - cont_height)/2;
		}

		self._container.setStyles({
			'left': left + shift_x + opts.offset.x,
			'top': top + shift_y + opts.offset.y
		});

		self._container.fade('in');
	},

	set_content: function(_el){
		var type_of = typeOf(this.options.content);
		var content;

		if(type_of == 'function'){
			content = this.options.content(_el);
		}else{
			content = this.options.content;
		}

		if(typeOf(content) == 'element'){
			this._tt_content.empty();
			var _clone = content.clone();
			_clone.inject(this._tt_content);
			_clone.show();
			//_clone.cloneEvents(content);
			this.cloneEventsDeep(content, _clone);

		}else{
			this._tt_content.set('html', content);
		}
	},
	cloneEventsDeep: function(from, to) {
		var self = this;
		to.cloneEvents(from);
		var fromChildren = from.getChildren();
		if (fromChildren.length > 0) {
			var toChildren = to.getChildren();
			fromChildren.each(function(item, index) {
				self.cloneEventsDeep(item, toChildren[index]);
			});
		}
	}
});
// Native.implement([Element, Window, Document], {

// });
